var Dot = require('./track/Dot');
var Event = require('./track/Event');
var EventCustom = require('./track/EventCustom');
var EventCustomDefinition = require('./track/EventCustomDefinition');
var NMEAFormatter = require('./utils/NMEAFormatter');

function FollowMeMapUtils() {}

FollowMeMapUtils.restoreDot = function(rawDot) {
  var dot = new Dot(
    rawDot.lat,
    rawDot.lon
  );
  var event = this.restoreEvent(rawDot.event, rawDot.eventType);

  if(event) {
    dot.setEventFromTable(event);
  }

  return dot;
};

FollowMeMapUtils.restoreEvent = function(event, eventType) {
  if(!event) return false;

  switch (eventType) {
    case 'Event':
      return new Event(
        event._id,
        event._name,
        event._description,
        event._color,
        event._isDefault,
        event._isDrawable
      );

    case 'EventCustomDefinition':
      return new EventCustomDefinition(
        event._id,
        event._color,
        event._definition,
        event._isDrawable
      );

    case 'EventCustom':
      return new EventCustom(
        event._id,
        event._name,
        event._content,
        event._color,
        event._isDrawable
      );
  }
};

/**
 * Translates a Dots collection to a CSV readable by the sever
 * @param {Dots} dots
 * @param includeCustomEventDefinitions
 * @param {string} format
 * @param {boolean} keepExactContent
 * @returns {string}
 */
FollowMeMapUtils.prepareForExport = function(dots, includeCustomEventDefinitions, format, keepExactContent) {
  if(!format) format = 'csv';
  switch (format) {
    case 'csv':
    default:
      return this.prepareForExportCSV(dots, includeCustomEventDefinitions, keepExactContent);
    case 'nmea':
      return this.prepareForExportNMEA(dots, includeCustomEventDefinitions, keepExactContent);
  }
};

/**
 *
 * @param {Dot[]} dots
 * @param {boolean} includeCustomEventDefinitions
 * @param {boolean} keepExactContent - if the content should be modified (e.g. if the description is missing, taking it from the name)
 * @returns {string}
 */
FollowMeMapUtils.prepareForExportCSV = function(dots, includeCustomEventDefinitions, keepExactContent) {
  var rowSeparator = ';';
  var header = ['lat', 'long', 'EVT_TYPE', 'EVT_DESCR', 'EVT_ID', 'EVT_NAME', 'EVT_COLOR', 'EVT_DEFAULT'];

  let customEventIds = [];
  let definitions = [];
  if(typeof window !== 'undefined') {
    definitions = window.storage.getCustomEventDefinitions();
  }

  if(!keepExactContent) {
    header.concat(['eventCode', 'eventText']);
  }

  if(dots.get().length <= 0) return;

  var populateArrayWithEvent = function(index, array, dot) {
    if(!dot.hasEvent()) return array;

    var event = dot.getEvent();

    switch (event.constructor.name) {
      case 'Event':
        let keepContentForEvent = keepExactContent;
        var description = event.getDescription();

        var eventId = event.getIsDefault() === true ? event.getId() : 1;
        if(eventId === 65555 || eventId === 65553) keepContentForEvent = true;

        if(!keepContentForEvent && event.getName() && event.getName() !== "" && description !== "") {
          description = event.getName() + ": " + event.getDescription();
        } else if(!keepContentForEvent && event.getName() && event.getName() !== "" && description === "") {
          description = event.getName();
        }

        array[header.indexOf('EVT_TYPE')] = eventId;
        array[header.indexOf('EVT_DESCR')] = description;
        array[header.indexOf('EVT_ID')] = eventId;
        array[header.indexOf('EVT_NAME')] = event.getName();
        array[header.indexOf('EVT_COLOR')] = event.getColor();
        array[header.indexOf('EVT_DEFAULT')] = event.getIsDefault();

        if(!keepContentForEvent) {
          array[header.indexOf('eventCode')] = eventId;
          array[header.indexOf('eventText')] = description;
        }

        break;

      case 'EventCustom':
        var eventIndex = 50000 + index;
        let eventDefinition = definitions.find(e => e._id === event.getId());

        let formattedContent = '';

        Object.keys(event.getContent()).forEach((key, i) => {
          formattedContent += key + '=' + event.getContent()[key];
          if(i !== Object.keys(event.getContent()).length-1) {
            formattedContent += ',';
          }
        });

        array[header.indexOf('EVT_TYPE')] = event.getId();
        array[header.indexOf('EVT_DESCR')] = formattedContent;
        array[header.indexOf('eventCode')] = event.getId();
        array[header.indexOf('EVT_COLOR')] = event.getColor();
        array[header.indexOf('eventText')] = JSON.stringify('evenTextWo?');
        break;
      /*
      case 'EventCustom':
        var parseEventText = function () {
          var content = event.getContent();
          var outputArray = [];

          for(var i in content) {
            if(!content.hasOwnProperty(i) || content[i] === null) continue;
            outputArray.push(i+"="+content[i]);
          }

          return outputArray.join(",");
        };

        array[header.indexOf('EVT_TYPE')] = event.getId();
        array[header.indexOf('EVT_DESCR')] = parseEventText();
        array[header.indexOf('eventCode')] = event.getId();
        array[header.indexOf('EVT_COLOR')] = event.getColor();
        array[header.indexOf('eventText')] = parseEventText();

        break;*/
    }

    return array;
  };

  var output = header.join(rowSeparator) + '\n';

  dots.get().forEach(function (dot, index) {
    var event = dot.getEvent();
    if(dot.hasEvent() && event.constructor.name === 'EventCustom') {
      customEventIds.push(event.getId());
    }
  });

  if(includeCustomEventDefinitions) {

    var id = 50000;

    let usedDefinitions = definitions.filter(def => customEventIds.includes(def._definition.code));

    var coordinatesLatitude = dots.get()[0].getLatitude().toString();
    var coordinatesLongitude = dots.get()[0].getLongitude().toString();
    usedDefinitions.forEach(function (def) {
      var outputArray = [
        coordinatesLatitude,
        coordinatesLongitude
      ];
      for(var i = 0; i < header.length - 2; i++) {
        outputArray.push("");
      }
      let definition = new EventCustomDefinition(def._id, def._color, def._definition, def._isDrawable);
      outputArray[header.indexOf('EVT_TYPE')] = id;
      outputArray[header.indexOf('EVT_DESCR')] = JSON.stringify(definition.getDefinition());
      outputArray[header.indexOf('eventCode')] = def._id;
      outputArray[header.indexOf('EVT_COLOR')] = definition.getColor();
      outputArray[header.indexOf('eventText')] = JSON.stringify(definition.getDefinition());
      output += outputArray.join(rowSeparator) + '\n';
      id++;
    });
  }

  dots.get().forEach(function (dot, index) {
    var outputArray = [
      dot.getLatitude().toString(),
      dot.getLongitude().toString()
    ];

    //Pre-populate events columns with empty values
    for(var i = 0; i < header.length - 2; i++) {
      outputArray.push("");
    }

    outputArray = populateArrayWithEvent(index, outputArray, dot);

    output += outputArray.join(rowSeparator) + '\n';
  });

  return output;
};

FollowMeMapUtils.getNMEAEventRow = function(dot, index, keepExactContent) {
  var event = dot.getEvent();
  var row = [];

  switch (event.constructor.name) {
    case 'Event':
      var description = event.getDescription();

      if(!keepExactContent && event.getName() && event.getName() !== "" && description !== "") {
        description = event.getName() + ": " + event.getDescription();
      } else if(!keepExactContent && event.getName() && event.getName() !== "" && description === "") {
        description = event.getName();
      }

      var eventId = event.getIsDefault() === true ? event.getId() : 1;

      row = ['$IWEVENT', eventId, description, dot.getLongitude(), dot.getLatitude()];
      break;

    case 'EventCustomDefinition':
      var eventIndex = 50000 + index;
      row = ['$IWEVENTDEFINITION', eventIndex, JSON.stringify(event.getDefinition()), dot.getLongitude(), dot.getLatitude()];
      break;

    case 'EventCustom':
      var parseEventText = function () {
        var content = event.getContent();
        var outputArray = [];

        for(var i in content) {
          if(!content.hasOwnProperty(i) || content[i] === null) continue;
          outputArray.push(i+"="+content[i]);
        }

        return outputArray.join(",");
      };

      row = ['$IWEVENT', event.getId(), parseEventText(), dot.getLongitude(), dot.getLatitude()];

      break;
  }

  return row.join(',');
};

FollowMeMapUtils.prepareForExportNMEA = function(dots, includeCustomEventDefinitions) {
  var nmeaFormatter = new NMEAFormatter();
  var output = [];

  var definitions = window.storage.getCustomEventDefinitions();
  var trackname = window.storage.getTrackInfo().fileName.replace(/ /g, "-");
  var id = 50000;

  if(definitions.hasOwnProperty(trackname) && definitions[trackname].length > 0) {
    var coordinatesLatitude = dots.get()[0].getLatitude().toString();
    var coordinatesLongitude = dots.get()[0].getLongitude().toString();

    definitions[trackname].forEach(function (definition) {
      output.push(
        ['$IWEVENTDEFINITION', id, JSON.stringify(definition.getDefinition()), coordinatesLongitude, coordinatesLatitude].join(',')
      );

      id++;
    });
  }

  dots.get().forEach(function (dot, index) {
    var coordinate = dot.getCoordinate();
    if(dot.hasEvent()) {
      output.push(this.getNMEAEventRow(dot, index));
    } else {
      output.push(nmeaFormatter.format(coordinate));
    }
  }.bind(this));

  return output.join('\n');
};

FollowMeMapUtils.getUserConfig = function(company, username) {
  var user = { company: '', username: '' };

  typeof company !== 'undefined' ? user.company = company : user.company = window.storage.getCompany();
  typeof username !== 'undefined' ? user.username = username : user.username = window.storage.getUsername();

  var userConfig;

  var specificUsernameKey = user.company + "/" + user.username;
  var specificCompanyKey = user.company + "/*";
  var generalKey = "*/*";

  if(Object.prototype.hasOwnProperty.call(CONSTANTS.MAP_RESTRICTIONS_PER_USER, specificUsernameKey)) {
    userConfig = CONSTANTS.MAP_RESTRICTIONS_PER_USER[specificUsernameKey];
  } else if(Object.prototype.hasOwnProperty.call(CONSTANTS.MAP_RESTRICTIONS_PER_USER, specificCompanyKey)) {
    userConfig = CONSTANTS.MAP_RESTRICTIONS_PER_USER[specificCompanyKey];
  } else {
    userConfig = CONSTANTS.MAP_RESTRICTIONS_PER_USER[generalKey];
  }

  return userConfig;
};

FollowMeMapUtils.sortMapTypes = function(mapTypes) {
  mapTypes.sort((a, b) => {
    var aString = a.provider + a.version;
    var bString = b.provider + b.version;

    if(aString < bString) {
      return -1;
    }

    if(aString > bString) {
      return 1;
    }

    return 0;
  });

  return mapTypes;
};

if(typeof window !== "undefined") window.FollowMeMapUtils = FollowMeMapUtils;

module.exports = FollowMeMapUtils;
